export default __webpack_public_path__ + "static/media/pic6.0ac4d69b.jpg";